module.exports = __webpack_public_path__ + "2ae269634e792ffaae8164146e2956f4.svg";